import { render, staticRenderFns } from "./register-verify-email.vue?vue&type=template&id=10acdbd7&"
import script from "./register-verify-email.vue?vue&type=script&lang=js&"
export * from "./register-verify-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports